import React from 'react';
import {
    Text,
    Font,
    Page,
    View,
    Image,
    StyleSheet,
} from '@react-pdf/renderer';
import logo from "../../assests/images/LuktukeLogo.png";
import { displayFormattedDate, formatDate, isEmpty } from '../../generalFunctions';
import { EMPTY_VALUE, GST_NUMBER, PDF_ALL_MARGIN, PDF_LEFT_MARGIN } from '../../constants';
import Signature from './common/Signature';

// Create styles
const styles = StyleSheet.create({
    page: {
        paddingLeft: PDF_LEFT_MARGIN,
        margin: PDF_ALL_MARGIN
    },
    container: {
        flexDirection: 'row',
        padding: 10
    },
    detailColumn: {
        flexDirection: 'column',
        flexGrow: 15,
        textTransform: 'uppercase',
    },
    linkColumn: {
        flexDirection: 'column',
        flexGrow: 2,
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    title: {
        fontSize: 12,
        fontWeight: "bold",
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
        width: 200,
        textAlign: "left",
        padding: 10,
        marginBottom: 5,
        textAlign: "center"
    },
    subtitle: {
        flexDirection: "column",
        flexGrow: 2,
        fontSize: 7,
        marginBottom: 2
    },
    image: {
        marginBottom: 5,
        width: 130,
        height: 80
    },
    ronumber: {
        flexDirection: "column",
        flexGrow: 1,
        fontSize: 10,
        fontWeight: "bold",
        marginLeft: 3
    }
});

Font.register({
    family: 'Open Sans',
    src: `https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0e.ttf`,
});

const displayMultipleDates = (dateOfInsertion) => {
    let dates = dateOfInsertion.split(",")
    let uniq = [...new Set(dates)];
    return uniq.toString().replace(/,/g, ", ");
};

// Create Document Component
const ReleaseOrderPdf = (props) => (
    <Page style={styles.page} id={props.data.id} size="A4">
        {/* header */}
        <View style={styles.container}>
            <View style={styles.detailColumn}>
                <Text style={styles.subtitle}>GST Number: {GST_NUMBER}</Text>
                <Text style={styles.title}>R  E  L  E  A  S  E     O  R  D  E  R</Text>
                <View style={{ flexDirection: "row", marginTop: 5 }}>
                    <Text style={styles.ronumber}>No. {props.data.id}</Text>
                    <Text style={{
                        flexDirection: "column",
                        flexGrow: 2,
                        fontSize: 10,
                        marginBottom: 15,
                        alignSelf: "flex-start"
                    }}>Date: {formatDate(props.data.roDate)}</Text>
                </View>
            </View>
            <View style={styles.linkColumn}>
                <Image
                    src={logo}
                    style={styles.image}
                />
            </View>
        </View>

        {/* publication and client details */}
        <View style={{ flexDirection: "row", padding: 10 }}>
            <Text style={{
                fontSize: 10,
                flexDirection: "column",
                flexGrow: 0.04
            }}>PUBLICATION:</Text>
            <Text style={{
                fontSize: 10,
                flexDirection: "column",
                marginRight: 20,
                flexGrow: 1,
                marginLeft: 15,
                width: "85%"
            }}>{props.data.publication}</Text>
        </View>

        <View style={{ flexDirection: "row", padding: 10 }}>
            <Text style={{
                fontSize: 10,
                flexDirection: "column",
                flexGrow: 0.05
            }}>CLIENT:</Text>
            <Text style={{
                fontSize: 10,
                flexDirection: "column",
                marginRight: 20,
                flexGrow: 1,
                marginLeft: 28
            }}>{props.data.client}</Text>
        </View>

        {/* Add type view language and date*/}
        <View style={{ flexDirection: "row", padding: 10 }}>
            <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center"
                }}>LANGUAGE</Text>
            </View>
            <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center"
                }}>DATE OF INSERTION</Text>
            </View>
        </View>

        <View style={{ flexDirection: "row" }}>
            <View style={{
                flexDirection: "column", padding: 10, flexGrow: 1, alignSelf: "center",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 1,
                marginRight: 25, width: "50%"
            }} >
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center"
                }}>{props.data.language}</Text>
            </View>
            <View style={{
                flexDirection: "column", padding: 10, flexGrow: 1, alignSelf: "center",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 1,
                marginRight: 25, width: "50%"
            }} >
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center"
                }}>{!isEmpty(props.data.scheme) ? props.data.scheme : (props.data.dateOfInsertion.split(",").length > 1 ? displayMultipleDates(props.data.dateOfInsertion) : displayFormattedDate(props.data.dateOfInsertion))}</Text>
            </View>
        </View>

        {/* Add type view size and caption*/}
        <View style={{ flexDirection: "row", padding: 10 }}>
            <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 10,
                    marginRight: 20,
                    display: "flex",
                    alignSelf: "center"
                }}>SIZE</Text>
            </View>
            <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 10,
                    marginRight: 20,
                    display: "flex",
                    alignSelf: "center"
                }}>CAPTION</Text>
            </View>
        </View>

        <View style={{ flexDirection: "row" }}>
            <View style={{
                flexDirection: "column", padding: 10, flexGrow: 0.70, alignSelf: "center",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 1,
                marginRight: 25,
                width: "50%"
            }} >
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center"
                }}>{props.isClassified ? "Classified" : props.data.width + " cm (w)  x " + props.data.height + " cm (h)"}</Text>
            </View>
            <View style={{
                flexDirection: "column", padding: 10, flexGrow: 1, alignSelf: "center",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 1,
                marginRight: 25, width: "50%"
            }} >
                <Text style={{
                    fontSize: 10,
                    display: "flex",
                    alignSelf: "center",
                    maxWidth: 200
                }}>{props.data.captionName}</Text>
            </View>
        </View>

        {/* Add type view material and filename*/}
        {!props.isClassified &&
            <>
                <View style={{ flexDirection: "row", padding: 10 }}>
                    <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                        <Text style={{
                            fontSize: 10,
                            marginRight: 20,
                            display: "flex",
                            alignSelf: "center"
                        }}>MATERIAL</Text>
                    </View>
                    <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                        <Text style={{
                            fontSize: 10,
                            marginRight: 20,
                            display: "flex",
                            alignSelf: "center"
                        }}>FILE NAME</Text>
                    </View>
                </View>

                <View style={{ flexDirection: "row" }}>
                    <View style={{
                        flexDirection: "column", padding: 10, flexGrow: 1, alignSelf: "center",
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        marginRight: 25, width: "50%"
                    }} >
                        <Text style={{
                            fontSize: 10,
                            display: "flex",
                            alignSelf: "center"
                        }}>{props.data.material}</Text>
                    </View>
                    <View style={{
                        flexDirection: "column", padding: 10, flexGrow: 1, alignSelf: "center",
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        marginRight: 25, width: "50%"
                    }} >
                        <Text style={{
                            fontSize: 10,
                            display: "flex",
                            alignSelf: "center"
                        }}>{props.data.file}</Text>
                    </View>
                </View>
            </>}



        {/* Add type view special instructions*/}
        <View style={{ flexDirection: "row", padding: 10 }}>
            <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 10,
                    marginRight: 20,
                    display: "flex",
                    alignSelf: "center"
                }}>SPECIAL INSTRUCTIONS</Text>
            </View>
        </View>

        <View style={{ flexDirection: "row" }}>
            <View style={{
                flexDirection: "column", padding: 5, flexGrow: 1, alignSelf: "flex-start",
                borderStyle: "solid",
                borderColor: "black",
                borderWidth: 1,
                marginRight: 25,
                lineHeight: 1.5
            }} >
                <Text style={{
                    fontSize: 10,
                }}>{!isEmpty(props.data.specialInstruction) ? props.data.specialInstruction : EMPTY_VALUE}</Text>
            </View>
        </View>

        {/* Add type view advance payment*/}
        {!isEmpty(props.data.advanceAmount) &&
            <>
                <View style={{ flexDirection: "row", padding: 10 }}>
                    <View style={{ flexDirection: "column", flexGrow: 1, alignSelf: "center", }}>
                        <Text style={{
                            fontSize: 10,
                            marginRight: 20,
                            display: "flex",
                            alignSelf: "center"
                        }}>ADVANCE PAYMENT</Text>
                    </View>
                </View>

                <View style={{ flexDirection: "row" }}>
                    <View style={{
                        flexDirection: "column", padding: 5, flexGrow: 1, alignSelf: "flex-start",
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        marginRight: 25,
                        marginBottom: 25,
                        lineHeight: 1.5
                    }} >
                        <Text style={{ fontSize: 10 }}>{`Amount: ${props.data.advanceAmount}`}
                            {!isEmpty(props.data.bank) && `    Bank: ${props.data.bank}`}
                            {!isEmpty(props.data.chequeNumber) && `    Payment Mode: ${props.data.type}`}</Text>
                        <Text style={{ fontSize: 10 }}>{!isEmpty(props.data.chequeNumber) && `Cheque Number: ${props.data.chequeNumber}`}
                            {!isEmpty(props.data.chequeDate) && `     Cheque Date: ${props.data.chequeDate}`}</Text>
                    </View>
                </View>
            </>}

        {/* signature */}
        <Signature />
    </Page>

);

export default ReleaseOrderPdf;